export default __webpack_public_path__ + "static/media/back.d991755d.svg";